import {
  fetchDeleteOfferFromFavorites,
  IDeleteOfferFromFavoritesRequest,
  IDeleteOfferFromFavoritesResponse,
  TDeleteOfferFromFavoritesResponse,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchRemoveFromFavorites(
  context: IApplicationContext,
  parameters: IDeleteOfferFromFavoritesRequest,
) {
  const { httpApi, logger } = context;

  try {
    const response: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
      httpApi,
      parameters,
    });

    return response.response as IDeleteOfferFromFavoritesResponse;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
